export default {
  menu: {
    top: "TOP",
    byMaker: "メーカー別",
    byEfficacy: "効能別",
    allProducts: "全商品",
    toAllProducts: "全商品を見る",
    howToUse: "使い方",
    select: "{filter}選択",
    modalTitle: {
      selectMaker: "メーカーを",
      selectTag: "効能を",
    },
  },
  products: {
    detailTitle: "商品の詳細",
    ingredients: "成分表記",
    basePrice: "本体価格",
    taxPrice: "税込",
    outOfStock: { button: "在庫切れ", note: "在庫切れの場合、従業員へお声がけください。" },
    buy: "購入",
    yen: "円",
    point: "ポイント",
    rank: "{rank}位",
    perItem: "/個",
    relatedProducts: "よく比較される商品",
  },
  printerStatus: {
    notReady: "Printer is not ready",
    paperStatus: {
      low: "The printer is low on paper",
      end: "The printer is out of paper",
    },
    coverOpen: "Cover is open",
    drawerOpen: "Drawer is open",
  },
  printModal: {
    button: "閉じる",
    state: {
      success: {
        title: "印刷しました",
        description: "レジにお持ちください",
      },
      error: {
        outOfPaper: {
          title: "用紙切れのため、印刷できません。用紙を補充してください。",
          description: "",
        },
      },
    },
  },
  receipt: {
    title: "購入引換券",
    dateTimeFormat: "{year}/{month}/{day} {hour}:{minute} 発行",
    maker: "メーカー",
    product_name: "商品名",
    quantity: "数量",
    quantityUnit: "{quantity}個",
    priceIncludingTax: "合計（税込）",
    yen: "円",
    shelfLocation: "棚番号",
    janCode: "JANコード",
    toCashier: "この券をレジにお持ちください",
    note: {
      0: "※商品のお渡しはレジにて行います。",
      1: "※後日ご購入時は在庫切れの可能性がございます。",
    },
  },
}
